




























































































































































import { Component, Vue } from 'vue-property-decorator';
import { constants } from '@/utils/constants';
import RdmReturnToBtn from '@/components/common/button/RdmReturnToBtn.vue';
import { productModule } from '@/store/modules/moduleProduct';
import { optionModule } from '@/store/modules/moduleOption';
import { travelerTypeModule } from '@/store/modules/moduleTravelerType';
import { Event } from '@/models';
import _ from 'lodash';
import OfferEditDescription from '@/components/offer/edit/OfferEditDescription.vue';
import OfferEditName from '@/components/offer/edit/OfferEditName.vue';
import OfferEditTicket from '@/components/offer/edit/OfferEditTicket.vue';
import OfferEditLocation from '@/components/offer/edit/OfferEditLocation.vue';
import OfferEditChannel from '@/components/offer/edit/OfferEditChannel.vue';
import OfferEditInventoryType from '@/components/offer/edit/OfferEditInventoryType.vue';
import OfferEditPolicy from '@/components/offer/edit/OfferEditPolicy.vue';
import OfferEditSchedules from '@/components/offer/edit/OfferEditSchedules.vue';
import OfferEditPricing from '@/components/offer/edit/OfferEditPricing.vue';
import OfferEditDetails from '@/components/offer/edit/OfferEditDetails.vue';
import OfferEditTaxes from '@/components/offer/edit/OfferEditTaxes.vue';
import RdmBanner from '@/components/common/banner/RdmBanner.vue';
import { httpModule } from '@/store/modules/moduleHttp';
import { companyModule } from '@/store/modules/moduleCompany';
import { offerModule } from '@/store/modules/moduleOffer';
import { eventsModule } from '@/store/modules/moduleEvents';

@Component({
  components: {
    OfferEditDetails,
    OfferEditPricing,
    OfferEditSchedules,
    OfferEditPolicy,
    OfferEditInventoryType,
    OfferEditChannel,
    OfferEditLocation,
    OfferEditTicket,
    OfferEditName,
    OfferEditDescription,
    OfferEditTaxes,
    RdmReturnToBtn,
    RdmBanner,
  },
})
export default class ProductOfferView extends Vue {
  private routeToOfferList = constants.routes.OFFER_LIST;

  async mounted() {
    // pricingModule.setProductOfferLoading(true);
    offerModule.clearState();
    await httpModule.getOffer({ offerId: this.$route.params.id });
    await httpModule.getUnpublishedChanges(this.$route.params.id);
    offerModule.startLoading();
    if (this.Offer.productId) {
      await httpModule.getProduct(this.Offer.productId).then();
      // await httpModule.getProductTripRoutes().then();
      // await httpModule.getProductUnitTravelerTypes(this.$route.params?.id).then();
      const id = companyModule.Organization?.ID || '';
      productModule.setProductCapacityPool({
        orgId: id,
        productId: this.Offer.productId,
        capacityPool: {
          pooled: 0,
          unlimited: false,
          byUnit: {} as Map<string, string>,
        },
      });
      offerModule.setProductCapacityPool({
        orgId: id,
        productId: this.Offer.productId,
        capacityPool: {
          pooled: 0,
          unlimited: false,
          byUnit: {} as Map<string, string>,
        },
      });
      await httpModule.getProductCapacity().then();
    }
    if (this.Offer.optionId) {
      const optionId = this.Offer.optionId || '';
      await httpModule.getOption(optionId).then();
      // await httpModule.getOptionTripRoutes().then();
      await httpModule.getOptionUnitTravelerTypes(optionId).then(() => {});
      const id = companyModule.Organization?.ID || '';
      optionModule.setOptionCapacityPool({
        orgId: id,
        optionId: optionId,
        capacityPool: {
          pooled: 0,
          unlimited: false,
          byUnit: {} as Map<string, string>,
        },
      });
      offerModule.setOptionCapacityPool({
        orgId: id,
        optionId: optionId,
        capacityPool: {
          pooled: 0,
          unlimited: false,
          byUnit: {} as Map<string, string>,
        },
      });
      await httpModule.getOptionCapacity().then();
    }
    await httpModule.getTaxesAndFees();
    if (!this.Offer || (this.Offer && _.isEmpty(this.Offer.id))) {
      this.$router.push({ name: this.routeToOfferList }).catch();
    }
    await offerModule.chooseCapacityType();
    offerModule.finishLoading();
    // todo set product offers
    // pricingModule.setProductOfferLoading(false);
  }

  destroyed() {
    // pricingModule.clearState();
    // productModule.clearState();
    // optionModule.clearState();
    offerModule.clearState(); // todo: possible to remove?
  }

  get OfferUnpublishedEvents() {
    return eventsModule.OfferUnpublishedEvents;
  }

  get showUnpublishedWarning(): boolean {
    return !!this.OfferUnpublishedEvents.find(
      (item: Event) => item.EntityType === 'offerPricing',
    );
  }
  get Loading() {
    // return pricingModule.ProductOfferLoading;
    return offerModule.Loading;
  }

  get Offer() {
    // return pricingModule.Offer;
    return offerModule.Offer;
  }

  get Product() {
    // return productModule.Product;
    return offerModule.Product;
  }

  get Option() {
    // return optionModule.Option;
    return offerModule.Option;
  }

  get OfferPricing() {
    // return pricingModule.OfferPricing;
    return offerModule.OfferPricing;
  }

  get TravelerTypes() {
    return travelerTypeModule.TravelerTypes;
  }
}
